import { useTheme } from "../context/ThemeContext";
import logoWhite from "../assets/logo-white.webp";
import logoBlack from "../assets/logo-black.webp";

// Approved RoadRnr wordmark. White asset in dark mode, black asset in light mode,
// switched by the existing theme state. Aspect ratio preserved. `className` is fully
// overridable so each surface can size it (default suits the mobile header). Assets
// used exactly as supplied — no recolour/crop/effects.
export const Logo = ({ className = "h-auto w-[clamp(145px,40vw,180px)] object-contain" }) => {
  const { resolved } = useTheme();
  const src = resolved === "light" ? logoBlack : logoWhite;
  return <img src={src} alt="RoadRnr" data-testid="rr-logo" className={className} />;
};
